import React , { useEffect , useState } from 'react'
import Add_QA_Modal from "../../../Components/Common/CustomModal/Add_QA_Modal";
import {
    ListGroup,
    ListGroupItem,
    Card,
    CardBody,
    CardHeader,
    Input,
    Label,
    Button
    } from "reactstrap";
import Question_Answer_List from '../Question_Answer_Component.js/Question_Answer_List';
import { uniqueId } from 'lodash';
import { useDispatch , useSelector } from 'react-redux';
import { update_Bot_Combine } from '../../../slices/thunks';
import Loader from '../../../Components/Common/Loader';



const QuestionAnswer = () => {

const [qa_list, setqa_list] = useState([])

const [selected_qa, setselected_qa] = useState([])


const dispatch = useDispatch()
const BotDetails = useSelector((state) => state.BotDetails.Bot_Details);
const  create_new_bot_details =  useSelector((state) => state.Create_Bot)


const [checkedAll, setcheckedAll] = useState(false)



const [question, setquestion] = useState('')

const [answer, setanswer] = useState('')


const [edit_mode, setedit_mode] = useState(false)

const [modal_animationZoom, setmodal_animationZoom] = useState(false);

const [edit_element, setedit_element] = useState([])


const onClick_Select_all = (e)=>{
     setcheckedAll(e.target.checked)
     if(e.target.checked){
         setselected_qa(qa_list)
     }else{
       setselected_qa([])
     }
}


const on_Delete_seleted = ()=>{

  
  
  const temp_qa = qa_list.filter((element)=> !selected_qa.includes(element))
    setqa_list(temp_qa)  
    setselected_qa([])      
}



const enable_edit_mode = (question , answer , ele)=>{
     setedit_mode(true)
     setmodal_animationZoom(true)
     setanswer(ele.answer)
     setquestion(ele.question)
     setedit_element(ele)
}


const onClick_update_qa = () => {

  let data = new FormData();
 
  data.append('assistant_id',BotDetails.Assets_ID)
  data.append('Bot_ID',BotDetails.Bot_ID)
  data.append('API_TYPE','QA')
  data.append('question_answers',JSON.stringify(qa_list))

  dispatch(update_Bot_Combine(data))

 

}


useEffect(() => {
  setqa_list(BotDetails.question_answers)
}, [BotDetails])
  



  return (
    <>
      <Card>
              <CardHeader>
              <div className="cust_header">
                <span>
                  <b>Q&A</b>
                </span>
                {!(create_new_bot_details.loading || BotDetails.loading ) && <Button color="secondary" onClick={onClick_update_qa} >Save</Button>}
                </div>
              </CardHeader>
              <CardBody>
                <div className="add_link">
                  <Add_QA_Modal edit_element={edit_element} modal_animationZoom={modal_animationZoom} setmodal_animationZoom={setmodal_animationZoom}  edit_mode={edit_mode} setedit_mode={setedit_mode} question={question} setquestion={setquestion} answer={answer} setanswer={setanswer}  qa_list={qa_list} setqa_list={setqa_list} />
                   
                </div>                
                <div className="sada_cs">
                  <div>
                    <span>
                      <div className="form-check form-check-outline form-check-primary mb-3">
                        <Input
                          className="form-check-input"
                          type="checkbox"
                          id="formCheck13"
                          checked={checkedAll}
                          onChange={onClick_Select_all}
                        />
                        <Label
                          className="form-check-label"
                          htmlFor="formCheck13"
                        >
                          Select all
                        </Label>
                      </div>
                    </span>
                    <span onClick={on_Delete_seleted} className="red">
                      <i className="ri-delete-bin-line"></i> Delete 
                    </span>
                  </div>
                </div>
                <div className="">
                  {(create_new_bot_details.loading || BotDetails.loading )? <Loader/>:<ListGroup>

                    {
                      qa_list?.map((ele, i)=>{
                          return <Question_Answer_List  enable_edit_mode={enable_edit_mode} question={question} setquestion={setquestion} answer={answer} setanswer={setanswer}  setqa_list={setqa_list}  qa_list={qa_list} ele={ele} key={i} id={ele.id || uniqueId()}  checkedAll={checkedAll} setcheckedAll={setcheckedAll} selected_qa={selected_qa} setselected_qa={setselected_qa} />

                      })
                    }
                    
                  </ListGroup>}
                </div>
              </CardBody>
            </Card>
    </>
  )
}

export default QuestionAnswer
